import React from 'react';
import { Body1, Card, Link, Subtitle1 } from '@fluentui/react-components';
import { useHelpPageStyles } from '../../styles/HelpPage.styles';
import {
  SUPPORT_BODY,
  SUPPORT_HEADING,
  SUPPORT_LINK_TEXT,
  SUPPORT_LINK_URL,
} from '../../constants/helpContent';

export const SupportTab: React.FC = () => {
  const styles = useHelpPageStyles();

  return (
    <Card className={styles.card}>
      <div className={styles.supportBody}>
        <Subtitle1 as="h2" className={styles.supportHeading}>
          {SUPPORT_HEADING}
        </Subtitle1>
        <Body1>{SUPPORT_BODY}</Body1>
        <Link href={SUPPORT_LINK_URL} target="_blank" rel="noopener noreferrer">
          {SUPPORT_LINK_TEXT}
        </Link>
      </div>
    </Card>
  );
};
